/**
 * @generated SignedSource<<ba59d541acb108ebb623d62d7f57799f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TutorialTeamSharedCalendar_flagsErrorable$data = {
  readonly __typename: "Flags";
  readonly flags: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "TutorialTeamSharedCalendar_flagsErrorable";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TutorialTeamSharedCalendar_flagsErrorable";
};
export type TutorialTeamSharedCalendar_flagsErrorable$key = {
  readonly " $data"?: TutorialTeamSharedCalendar_flagsErrorable$data;
  readonly " $fragmentSpreads": FragmentRefs<"TutorialTeamSharedCalendar_flagsErrorable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TutorialTeamSharedCalendar_flagsErrorable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flags",
          "storageKey": null
        }
      ],
      "type": "Flags",
      "abstractKey": null
    }
  ],
  "type": "FlagsErrorable",
  "abstractKey": "__isFlagsErrorable"
};

(node as any).hash = "4cc159dc84bac9902e6a68b87980dede";

export default node;
